import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';


import LoginScreen from './components/LoginScreen';
import ProcessingModal from './components/ProcessingModal';
import MapaPage from './pages/MapaPage';
import FormulariosPage from './pages/FormulariosPage';
import ExamesPage from './pages/ExamesPage';
import BorrifacaoPage from './pages/BorrifacaoPage';
import LocalidadesPage from './pages/LocalidadesPage';
import VigilanciaPassivaPage from './pages/VigilanciaPassivaPage';
import GerenciamentoPage from './pages/GerenciamentoPage';




function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {

    try {
      document.documentElement.scrollTop = 0; // Para navegadores modernos
      document.body.scrollTop = 0; // Para Safari e outros
    } catch (e) {

    }
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LoginScreen />} />
        <Route path="/formularios" element={<FormulariosPage />} />
        <Route path="/exames" element={<ExamesPage />} />
        <Route path="/borrifacao" element={<BorrifacaoPage />} />
        <Route path="/localidades" element={<LocalidadesPage />} />
        <Route path="/vigilancia-passiva" element={<VigilanciaPassivaPage />} />
        <Route path="/agentes" element={<GerenciamentoPage />} />
        <Route path="/mapa" element={<MapaPage />} />
        <Route path="/ficha-campo" element={<ProcessingModal />} />
        {/* Redireciona URLs antigas do dashboard para a rota padrão */}
        <Route path="/dashboard" element={<Navigate to="/formularios" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
